import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import "./i18n"

import App from "./App"
import * as serviceWorker from "./serviceWorker"

import store from "./store"

let stripeKey = ''
const hostname = window && window.location && window.location.hostname
switch (hostname) {
    case 'localhost':
        stripeKey = 'pk_test_51HnZW5JkZvW0xpviYQpOX1yO4KHqOao79391AeUntWeuVQsZZNh79kZaiZnI3or76rHNoL0KMv10x0iMH8HNXVLH00yLvqjfJC'
        break
    case 'dev.vendora.com.mx':
        stripeKey = 'pk_test_51HnZW5JkZvW0xpviYQpOX1yO4KHqOao79391AeUntWeuVQsZZNh79kZaiZnI3or76rHNoL0KMv10x0iMH8HNXVLH00yLvqjfJC'
        break
    default: // Es producción
        stripeKey = 'pk_live_51HnZW5JkZvW0xpviUIvN66hrnPUEL0PSLGwXZhv347MRmMG8CZjjfVsXmQXQ1U752iFVrqUbksz5GrhPBImYoCJ300Xm8cE4il'
        break
}

const stripePromise = loadStripe(stripeKey)

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <Elements stripe={stripePromise}>
                <App />
            </Elements>
        </BrowserRouter>
    </Provider>
)

ReactDOM.render(app, document.getElementById("root"))

serviceWorker.unregister()
